import { useToast } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { elegibleUserData } from '../../apis/elegibleUserData'
import { registerUser } from '../../apis/registerUser'
import { useIamStore } from '../../apis/store'
import { Area } from '../../domain/area'

const useRegisterElegibleUser = () => {
  const [t] = useTranslation()
  const { userEmail, sendEvent } = useIamStore((state) => ({ userEmail: state.userEmail, sendEvent: state.sendEvent }))
  const toast = useToast()
  const [elegibleUser, setElegibleUser] = React.useState<{
    areas: Area[]
    isLoading: boolean
    sending: boolean
    user: { name: string; area: { id: number }; areaName: string; email: string }
  }>({
    isLoading: true,
    sending: false,
    user: { name: '', area: { id: 0 }, areaName: '', email: userEmail },
    areas: [],
  })
  const register = React.useCallback(
    (data: { name: string; area: { id: number }; email: string; password: string }) => {
      setElegibleUser((data) => ({
        ...data,
        sending: true,
      }))
      registerUser(data)
        .then(() => {
          setElegibleUser((data) => ({
            ...data,
            sending: false,
          }))
          sendEvent({ type: 'VALID_REGISTER' })
        })
        .catch(() => {
          setElegibleUser((data) => ({
            ...data,
            sending: false,
          }))
          toast({
            title: t('login.validation.Something went wrong'),
            isClosable: true,
            duration: 5000,
            status: 'error',
          })
        })
    },
    [toast, sendEvent, t],
  )
  React.useEffect(() => {
    elegibleUserData({ email: userEmail })
      .then((res) => {
        setElegibleUser((data) => ({
          ...data,
          isLoading: false,
          user: {
            ...data.user,
            name: res?.name || '',
            area: { id: res?.area?.id || 0 },
            areaName: res?.area?.name || '',
          },
          areas: res?.companyAreas || [],
        }))
      })
      .catch(() => {
        setElegibleUser((data) => ({
          ...data,
          isLoading: false,
        }))
        toast({
          title: t('login.validation.Something went wrong'),
          isClosable: true,
          duration: 5000,
          status: 'error',
        })
      })
  }, [t, toast, userEmail])
  return { elegibleUser, register }
}

export default useRegisterElegibleUser
